import { render } from "./СreateTemplate.vue?vue&type=template&id=96afe674"
import script from "./СreateTemplate.vue?vue&type=script&lang=js"
export * from "./СreateTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__